// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

body {
    background-color: #f1f5f9 !important;
    color: #0f172a;
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    min-height: 100vh;
}

/* Kontenery */
.container,
.container-fluid {
    background-color: transparent !important;
}

/* Karty */
.card {
    background-color: #ffffff;
    border: none !important;
    border-radius: 12px !important;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06) !important;
    transition: box-shadow 0.2s ease;
}

.card:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08) !important;
}

/* Listy */
.list-group-item {
    background-color: #ffffff;
    border-color: #f1f5f9 !important;
}

.list-group-item:first-child {
    border-top-left-radius: 12px !important;
    border-top-right-radius: 12px !important;
}

.list-group-item:last-child {
    border-bottom-left-radius: 12px !important;
    border-bottom-right-radius: 12px !important;
}

/* Navbar */
.navbar {
    background-color: #ffffff !important;
    border-bottom: 1px solid #e2e8f0 !important;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04) !important;
}

/* Alerty */
.alert {
    border: none !important;
    border-radius: 10px !important;
}

/* Przyciski */
.btn {
    border-radius: 8px !important;
    font-weight: 500 !important;
    padding: 0.5rem 1rem !important;
    transition: all 0.2s ease !important;
}

.btn-primary {
    background-color: #6366f1 !important;
    border-color: #6366f1 !important;
}

.btn-primary:hover {
    background-color: #4f46e5 !important;
    border-color: #4f46e5 !important;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(99, 102, 241, 0.3) !important;
}

.btn-outline-primary {
    color: #6366f1 !important;
    border-color: #6366f1 !important;
}

.btn-outline-primary:hover {
    background-color: #6366f1 !important;
    color: white !important;
}

/* Badge */
.badge {
    padding: 0.4rem 0.7rem !important;
    border-radius: 6px !important;
    font-weight: 500 !important;
}

/* Formularze */
.form-control,
.form-select {
    border-radius: 8px !important;
    border-color: #e2e8f0 !important;
}

.form-control:focus,
.form-select:focus {
    border-color: #6366f1 !important;
    box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.15) !important;
}

/* Modal */
.modal-content {
    border: none !important;
    border-radius: 16px !important;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15) !important;
}
.lesson-item {
    transition: background-color 0.2s ease !important;
    border-radius: 8px !important;
}

.lesson-item:hover {
    background-color: #f1f5f9 !important;  
    cursor: pointer;
}

.navbar-brand img {
    background-color: transparent !important;
    filter: drop-shadow(0 1px 2px rgba(0,0,0,0.05));
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":";AACA;IACI,SAAS;IACT,UAAU;IACV,sBAAsB;AAC1B;;AAEA;IACI,oCAAoC;IACpC,cAAc;IACd,uFAAuF;IACvF,iBAAiB;AACrB;;AAEA,cAAc;AACd;;IAEI,wCAAwC;AAC5C;;AAEA,UAAU;AACV;IACI,yBAAyB;IACzB,uBAAuB;IACvB,8BAA8B;IAC9B,oDAAoD;IACpD,gCAAgC;AACpC;;AAEA;IACI,qDAAqD;AACzD;;AAEA,UAAU;AACV;IACI,yBAAyB;IACzB,gCAAgC;AACpC;;AAEA;IACI,uCAAuC;IACvC,wCAAwC;AAC5C;;AAEA;IACI,0CAA0C;IAC1C,2CAA2C;AAC/C;;AAEA,WAAW;AACX;IACI,oCAAoC;IACpC,2CAA2C;IAC3C,oDAAoD;AACxD;;AAEA,WAAW;AACX;IACI,uBAAuB;IACvB,8BAA8B;AAClC;;AAEA,cAAc;AACd;IACI,6BAA6B;IAC7B,2BAA2B;IAC3B,+BAA+B;IAC/B,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;IACpC,gCAAgC;AACpC;;AAEA;IACI,oCAAoC;IACpC,gCAAgC;IAChC,2BAA2B;IAC3B,yDAAyD;AAC7D;;AAEA;IACI,yBAAyB;IACzB,gCAAgC;AACpC;;AAEA;IACI,oCAAoC;IACpC,uBAAuB;AAC3B;;AAEA,UAAU;AACV;IACI,iCAAiC;IACjC,6BAA6B;IAC7B,2BAA2B;AAC/B;;AAEA,eAAe;AACf;;IAEI,6BAA6B;IAC7B,gCAAgC;AACpC;;AAEA;;IAEI,gCAAgC;IAChC,yDAAyD;AAC7D;;AAEA,UAAU;AACV;IACI,uBAAuB;IACvB,8BAA8B;IAC9B,sDAAsD;AAC1D;AACA;IACI,iDAAiD;IACjD,6BAA6B;AACjC;;AAEA;IACI,oCAAoC;IACpC,eAAe;AACnB;;AAEA;IACI,wCAAwC;IACxC,+CAA+C;AACnD","sourcesContent":["\n* {\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n}\n\nbody {\n    background-color: #f1f5f9 !important;\n    color: #0f172a;\n    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n    min-height: 100vh;\n}\n\n/* Kontenery */\n.container,\n.container-fluid {\n    background-color: transparent !important;\n}\n\n/* Karty */\n.card {\n    background-color: #ffffff;\n    border: none !important;\n    border-radius: 12px !important;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06) !important;\n    transition: box-shadow 0.2s ease;\n}\n\n.card:hover {\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08) !important;\n}\n\n/* Listy */\n.list-group-item {\n    background-color: #ffffff;\n    border-color: #f1f5f9 !important;\n}\n\n.list-group-item:first-child {\n    border-top-left-radius: 12px !important;\n    border-top-right-radius: 12px !important;\n}\n\n.list-group-item:last-child {\n    border-bottom-left-radius: 12px !important;\n    border-bottom-right-radius: 12px !important;\n}\n\n/* Navbar */\n.navbar {\n    background-color: #ffffff !important;\n    border-bottom: 1px solid #e2e8f0 !important;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04) !important;\n}\n\n/* Alerty */\n.alert {\n    border: none !important;\n    border-radius: 10px !important;\n}\n\n/* Przyciski */\n.btn {\n    border-radius: 8px !important;\n    font-weight: 500 !important;\n    padding: 0.5rem 1rem !important;\n    transition: all 0.2s ease !important;\n}\n\n.btn-primary {\n    background-color: #6366f1 !important;\n    border-color: #6366f1 !important;\n}\n\n.btn-primary:hover {\n    background-color: #4f46e5 !important;\n    border-color: #4f46e5 !important;\n    transform: translateY(-1px);\n    box-shadow: 0 4px 12px rgba(99, 102, 241, 0.3) !important;\n}\n\n.btn-outline-primary {\n    color: #6366f1 !important;\n    border-color: #6366f1 !important;\n}\n\n.btn-outline-primary:hover {\n    background-color: #6366f1 !important;\n    color: white !important;\n}\n\n/* Badge */\n.badge {\n    padding: 0.4rem 0.7rem !important;\n    border-radius: 6px !important;\n    font-weight: 500 !important;\n}\n\n/* Formularze */\n.form-control,\n.form-select {\n    border-radius: 8px !important;\n    border-color: #e2e8f0 !important;\n}\n\n.form-control:focus,\n.form-select:focus {\n    border-color: #6366f1 !important;\n    box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.15) !important;\n}\n\n/* Modal */\n.modal-content {\n    border: none !important;\n    border-radius: 16px !important;\n    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15) !important;\n}\n.lesson-item {\n    transition: background-color 0.2s ease !important;\n    border-radius: 8px !important;\n}\n\n.lesson-item:hover {\n    background-color: #f1f5f9 !important;  \n    cursor: pointer;\n}\n\n.navbar-brand img {\n    background-color: transparent !important;\n    filter: drop-shadow(0 1px 2px rgba(0,0,0,0.05));\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
